import { render, staticRenderFns } from "./TCISwitchHeader.vue?vue&type=template&id=344e1968&"
import script from "./TCISwitchHeader.vue?vue&type=script&lang=js&"
export * from "./TCISwitchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports